import type { CapiProductPage } from 'types/capi/pdp';

import { Button } from '~/components/Button';
import ProductNotificationButton from '~/components/ProductNotificationButton';
import usePageData from '~/hooks/usePageData';

import AnimatedFrame from './AnimatedFrame';

const UpcomingReleaseText = () => {
  return (
    <p className="w-full">
      This product is{' '}
      <span className="text-purple-hola-light">coming soon</span>, set a release
      notification.
    </p>
  );
};

const SoldOutText = () => {
  return (
    <p className="w-full">
      This product is <span className="text-red-alert-light">sold out</span>,
      set a restock notification.
    </p>
  );
};

type BannerType = 'sold-out' | 'upcoming';

type Props = {
  bannerType: BannerType;
  onDismiss: () => void;
};

const NotificationBanner = ({ bannerType, onDismiss }: Props) => {
  const product = usePageData<CapiProductPage>();

  return (
    <AnimatedFrame>
      <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-2 p-4 md:flex-row md:px-8">
        {bannerType === 'upcoming' ? <UpcomingReleaseText /> : <SoldOutText />}
        <div className="flex w-full gap-2">
          <Button
            onClick={onDismiss}
            className="w-1/3"
            variant="transparent-white-border"
          >
            Dismiss
          </Button>
          <div className="w-2/3">
            <ProductNotificationButton
              product={{
                id: product.product_id,
                image: product.gallery[0],
                legacyId: product.legacy_id,
                name: product.name,
                price: product.price.regular
              }}
              className="min-h-12"
              pagePosition="Banner"
              buttonStyle="normal"
            />
          </div>
        </div>
      </div>
    </AnimatedFrame>
  );
};

export default NotificationBanner;
